export const dynamicPricing = {
  title: "Dynamische Preise",
  loading: "Einstellungen werden geladen…",
  status: {
    active: "An",
    inactive: "Aus",
  },
  close: "Schließen",
  unit: {
    label: "Unterkunft",
    autoPill: "✦ Automatisch aus Ihrer Historie",
  },
  tabs: {
    calendario: "Kalender",
    precio: "Basispreis",
    reglas: "Regeln",
    aplicacion: "Anwendung",
  },
  weekdaysShort: {
    mon: "Mo",
    tue: "Di",
    wed: "Mi",
    thu: "Do",
    fri: "Fr",
    sat: "Sa",
    sun: "So",
  },
  cal: {
    stats: {
      adr: "Progn. ADR",
      occupancy: "Belegung",
      revenue: "Umsatz",
    },
    calculating: "Preise werden berechnet…",
    minStayShort: "min. {count} N | min. {count} N",
  },
  legend: {
    low: "Niedrig",
    base: "Basis",
    high: "Hoch",
    peak: "Spitze",
    booked: "Gebucht",
    override: "Fest",
  },
  why: {
    title: "Warum {price} {curr} · {day}",
    chip: "Erklärung",
    nights: "{count} Nacht | {count} Nächte",
    minStay: "Mindestaufenthalt: {nights} · Untergrenze {floor} / Obergrenze {ceil} {curr}",
    hint: "Tippen Sie auf einen Tag, um zu sehen, wie sich sein Preis zusammensetzt.",
  },
  apply: {
    diffPrefix: "Mit den vorgeschlagenen Preisen:",
    diffSuffix: "gegenüber Ihren aktuellen Preisen für {month}.",
    apply: "Preise anwenden",
    applying: "Wird angewendet…",
    applyNow: "Jetzt anwenden",
    enableToApply: "Aktivieren Sie Dynamische Preise, um sie anzuwenden.",
    enableFirst: "Aktivieren Sie zuerst Dynamische Preise.",
    autoNote: {
      prefix: "✓ Im Modus",
      mode: "Automatisch",
      mid: "gelten die Preise",
      everyday: "jeden Tag",
    },
    result: {
      hotelPending: "Hotels (mehrere Einheiten) werden in dieser Phase noch nicht unterstützt.",
      ok: "✓ {count} Tag angewendet ({from} → {to}) und an die Kanäle gesendet. | ✓ {count} Tage angewendet ({from} → {to}) und an die Kanäle gesendet.",
      failed: "Die Preise konnten nicht angewendet werden.",
    },
  },
  base: {
    title: "Basispreis und Grenzen",
    desc: "Vorschlag aus Ihrer Historie. Der Motor verlässt diesen Bereich nie.",
    basePerNight: "Basis / Nacht",
    min: "Minimum (Untergrenze)",
    max: "Maximum (Obergrenze)",
    rounding: "Rundung",
  },
  rounding: {
    integer: "Ganzzahl",
    ends0: "Endet auf 0",
    ends9: "Endet auf 9",
    multiple5: "Vielf. 5",
  },
  weekend: {
    title: "Wochenende und Mindestaufenthalt",
    upliftLabel: "Wochenendaufschlag",
    daysLabel: "Wochenendtage:",
    minStayLabel: "Mindestaufenthalt (Nächte)",
    minStayNormal: "Standard",
    minStayWeekend: "Wochenende / hoch",
    orphanTitle: "Einzelne Restnächte füllen",
    orphanDesc: "Kürzere Aufenthalte ({pct} % Rabatt) in Lücken von 1–2 Nächten.",
  },
  demand: {
    title: "Nachfrageempfindlichkeit",
    desc: "Wie stark Belegung und Buchungstempo den Preis bewegen.",
  },
  aggr: {
    low: "Konservativ",
    medium: "Mittel",
    high: "Aggressiv",
  },
  seasons: {
    title: "Saisons",
    namePlaceholder: "Name",
    monthDayPlaceholder: "MM-TT",
    add: "+ Saison hinzufügen",
  },
  events: {
    title: "Events (Messen, Festivals…)",
    suggestWithAI: "✨ Mit KI vorschlagen",
    suggesting: "Suche läuft…",
    namePlaceholder: "Name",
    datePlaceholder: "JJJJ-MM-TT",
    empty: "Keine Events. Fügen Sie sie manuell oder mit KI hinzu.",
    add: "+ Event hinzufügen",
    suggestionsHead: "KI-Vorschläge{city}: Daten prüfen und hinzufügen",
    addSuggestion: "+ Hinzufügen",
    noSuggestions: "Keine Vorschläge (prüfen Sie, ob für die Unterkunft eine Stadt hinterlegt ist).",
  },
  demandRules: {
    title: "Nachfrageregeln",
    lastMinuteTitle: "Last-Minute-Rabatte",
    lastMinuteDesc: "Senkt den Preis für nahe Termine, die noch frei sind.",
    holidaysTitle: "Automatische Feiertage",
    holidaysDesc: "Wendet an nationalen Feiertagen +{pct} % an.",
    occupancyTitle: "Erhöhen nach Belegung",
    occupancyDesc: "Wenn der Monat zu mehr als {threshold} % belegt ist, den Preis erhöhen.",
    weeklyDiscount: "Wochenrabatt (7+) %",
    monthlyDiscount: "Monatsrabatt (28+) %",
  },
  application: {
    title: "Modus und Synchronisierung",
    modeLabel: "Anwendungsmodus",
    modeSuggested: "Vorschlag (ich prüfe zuerst)",
    modeAuto: "Automatisch",
    syncTitle: "Mit Kanälen synchronisieren (Channex → Airbnb / Booking)",
    syncDesc: "Veröffentlicht die berechneten Preise auf Ihren Kanälen.",
    horizonLabel: "Berechnungshorizont",
    horizonMonths: "{count} Monate",
  },
  save: {
    saved: "Gespeichert ✓",
    saving: "Wird gespeichert…",
    save: "Änderungen speichern",
  },
  errors: {
    forbidden: "Sie haben keinen Zugriff auf diese Unterkunft.",
    loadFailed: "Die Einstellungen konnten nicht geladen werden.",
    saveFailed: "Speichern nicht möglich. Prüfen Sie die Felder.",
  },
};
